// Available file types for @cyntler/react-doc-viewer
export const availableTypes = [
  "bmp",
  "csv",
  "odt",
  "doc",
  "docx",
  "gif",
  "htm",
  "html",
  "jpg",
  "jpeg",
  "pdf",
  "png",
  "ppt",
  "pptx",
  "tiff",
  "txt",
  "xls",
  "xlsx",
  "mp4",
  "webp",
];
